import { useState, useEffect, useRef } from 'react'
import { useLocation } from 'react-router'
import { observer, inject } from 'mobx-react'
import { withRouterProps } from '../../../utils'
import PensionSingle from './PensionSingle'
import PensionMarried from './PensionMarried'
import Success from './Success'
import WelcomeSpendingMode from './WelcomeSpendingMode'
import _ from 'lodash'

function Dashboard(props) {
  const {
    navigate,
    store: { getSurvivorPensionOptions },
    onboarding: {
      person: { maritalStatus, includeSpouse },
      config: { isRetail, isSpendown },
    },
  } = props
  const [status, setStatus] = useState('single')
  const [pensionOptions, setPensionOptions] = useState({})
  const isMounted = useRef(false)
  const location = useLocation()

  useEffect(() => {
    isMounted.current = true
    const fetchData = async () => {
      try {
        const result = await getSurvivorPensionOptions()
        if (_.isEmpty(result)) {
          setStatus('success')
          return null
        }
        setPensionOptions(result)
      } catch (err) {
        console.error(err)
      }
    }
    if (isMounted.current) {
      fetchData()
    }

    return () => {
      isMounted.current = false
    }
  }, [getSurvivorPensionOptions])

  if (status === 'success' && _.get(location, 'state.from', null) === '/home') {
    navigate('/spending')
  }

  if (status === 'success') {
    if (isRetail && isSpendown) {
      return <WelcomeSpendingMode props={props}></WelcomeSpendingMode>
    }
    return <Success props={props} />
  }

  return maritalStatus && includeSpouse ? (
    <PensionMarried pensionOptions={pensionOptions} setStatus={setStatus} />
  ) : (
    <PensionSingle pensionOptions={pensionOptions} setStatus={setStatus} />
  )
}

export default withRouterProps(inject('onboarding', 'store')(observer(Dashboard)))
